/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pencil-edit': {
    width: 16,
    height: 8,
    viewBox: '0 0 16 8',
    data: '<defs><path pid="0" d="M6 4a.666.666 0 110 1.333H4.667A2.668 2.668 0 002.01 8.244c.125 1.4 1.392 2.423 2.796 2.423H6A.666.666 0 116 12H4.667A4.005 4.005 0 01.7 7.474C.959 5.458 2.773 4 4.806 4zm5.173 0c2.044 0 3.88 1.465 4.13 3.495A4.004 4.004 0 0111.332 12H10a.666.666 0 110-1.333h1.333a2.668 2.668 0 002.656-2.91c-.125-1.4-1.392-2.424-2.796-2.424H10a.666.666 0 01-.667-.666c0-.369.296-.667.833-.667zM10 7.333a.666.666 0 110 1.334H6a.666.666 0 110-1.334z" id="svgicon_pencil-edit_a"/></defs><use _fill="#005BA5" xlink:href="#svgicon_pencil-edit_a" transform="translate(0 -4)" fill-rule="evenodd"/>'
  }
})
